const colors = {
  'action-primary': 'var(--maui-color-action-primary-default)',
  'action-primary--emphasis': 'var(--maui-color-action-primary-pressed)',
  'action-primary--deemphasis': 'var(--maui-color-action-primary-hover)',
  'action-secondary': 'var(--maui-color-action-secondary-default)',
  'action-secondary--emphasis': 'var(--maui-color-action-secondary-pressed)',
  'action-secondary--deemphasis': 'var(--maui-color-action-secondary-hover)',
  'action-destructive': 'var(--maui-color-action-destructive-default)',
  'action-destructive--emphasis': 'var(--maui-color-action-destructive-pressed)',
  'action-destructive--deemphasis': 'var(--maui-color-action-destructive-hover)',
  'color-page-background--solid': 'var(--maui-color-background-page)',
  'color-background-primary': 'var(--maui-color-background-surface)',
  'color-background-primary--bright': 'var(--maui-color-background-overlay)',
  'color-background-primary--dim': 'var(--maui-color-background-page)',
  'color-background-secondary': '#49515d',
  'color-background-secondary--bright': '#f9f9f9',
  'color-background-secondary--dim': '#323c48',
  'active-primary': 'var(--maui-color-active-primary)',
  'active-secondary': 'var(--maui-color-active-secondary)',
  'active--reverse': 'var(--maui-color-active-reversed)',
  border: 'var(--maui-color-border-main)',
  'border--emphasis': 'var(--maui-color-border-emphasis)',
  'border--deemphasis': 'var(--maui-color-border-deemphasis)',
  'border--reverse': 'var(--maui-color-active-reversed)',
  text: 'var(--maui-color-text-main)',
  'text--emphasis': 'var(--maui-color-text-emphasis)',
  'text--deemphasis': 'var(--maui-color-text-deemphasis)',
  'text--reverse': 'var(--maui-color-text-reversed)',
  'feedback--error': 'var(--maui-color-feedback-error)',
  'feedback--warning': 'var(--maui-color-feedback-warning)',
  'feedback--success': 'var(--maui-color-feedback-success)',
  'feedback--info': 'var(--maui-color-feedback-info)',
  'risk--critical': 'var(--maui-color-risk-critical)',
  'risk--high': 'var(--maui-color-risk-high)',
  'risk--medium': 'var(--maui-color-risk-medium)',
  'risk--low': 'var(--maui-color-risk-low)',
  'risk--benign': 'var(--maui-color-risk-benign)',
  actionPrimary: 'var(--maui-color-action-primary-default)',
  actionPrimaryHover: 'var(--maui-color-action-primary-hover)',
  actionPrimaryPressed: 'var(--maui-color-action-primary-pressed)',
  'freemium-lock': 'var(--maui-color-other-freemium-lock)'
}
export default colors
